/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  name: 'rcdss',
  production: true,
  apiUrl: 'https://api.rcdss.ionsupply.com',
  socketsUrl: 'https://api.rcdss.ionsupply.com:8081',
  socketsApiUrl: 'wss://api.rcdss.ionsupply.com:8081/ws',
  defaultRealmId: null,
  calendlyEventUrl: 'https://calendly.com/jeff-ives/ion-training',
  googleMapsApiKey: 'AIzaSyBWpsuhmTgZN_bvRGlSbEG1RWtEqtcTRkU',
};
